import { resolveRef } from "./schema-context.js";
export function generateDefaults(schema, ctx) {
    const resolved = ctx ? resolveRef(ctx, schema) : schema;
    // If schema has a const value, use that
    if (resolved.const !== undefined)
        return resolved.const;
    // If schema has a single-value enum, use that as the default (common for discriminators)
    if (Array.isArray(resolved.enum) && resolved.enum.length === 1) {
        return resolved.enum[0];
    }
    if (resolved.default !== undefined)
        return structuredClone(resolved.default);
    const type = resolved.type;
    if (Array.isArray(type)) {
        const firstType = type.find((t) => t !== 'null');
        if (firstType)
            return generateDefaultForType(firstType, resolved, ctx);
        return null;
    }
    return generateDefaultForType(type, resolved, ctx);
}
function generateDefaultForType(type, schema, ctx) {
    switch (type) {
        case 'string':
            return '';
        case 'number':
        case 'integer':
            return (schema.minimum ?? 0);
        case 'boolean':
            return false;
        case 'null':
            return null;
        case 'array':
            return [];
        case 'object':
            return generateObjectDefaults(schema, ctx);
        default:
            if (schema.oneOf || schema.anyOf) {
                const variants = (schema.oneOf ?? schema.anyOf);
                if (variants.length > 0) {
                    const variant = ctx ? resolveRef(ctx, variants[0]) : variants[0];
                    return generateDefaults(variant, ctx);
                }
            }
            return undefined;
    }
}
function generateObjectDefaults(schema, ctx) {
    const result = {};
    const properties = schema.properties;
    const required = schema.required ?? [];
    if (!properties)
        return result;
    for (const [key, propSchema] of Object.entries(properties)) {
        const resolved = ctx ? resolveRef(ctx, propSchema) : propSchema;
        if (required.includes(key)) {
            result[key] = generateDefaults(resolved, ctx);
        }
        else if (resolved.default !== undefined) {
            result[key] = structuredClone(resolved.default);
        }
    }
    return result;
}
export function generateArrayItemDefault(schema, ctx) {
    if (!schema.items)
        return {};
    const rawItemSchema = Array.isArray(schema.items) ? schema.items[0] : schema.items;
    const itemSchema = ctx ? resolveRef(ctx, rawItemSchema) : rawItemSchema;
    return generateDefaults(itemSchema, ctx);
}
export function generateDiscriminatedDefault(schema, discriminatorPath, discriminatorValue, ctx) {
    const variants = (schema.oneOf ?? schema.anyOf);
    if (!variants)
        return {};
    for (const variant of variants) {
        const resolved = ctx ? resolveRef(ctx, variant) : variant;
        const props = resolved.properties;
        const discProp = props?.[discriminatorPath];
        // Check for const value or single-value enum (common for discriminators)
        const constValue = discProp?.const ?? (Array.isArray(discProp?.enum) && discProp?.enum.length === 1 ? discProp?.enum[0] : undefined);
        if (constValue === discriminatorValue) {
            return generateDefaults(resolved, ctx);
        }
    }
    const firstVariant = ctx ? resolveRef(ctx, variants[0]) : variants[0];
    return generateDefaults(firstVariant, ctx);
}
